import { FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';
import { WIZARD_SCREEN_TYPES } from '../../../constants/stringConstants';

export default function HaveYouAlreadyFoundYourNewTenants({ onRadioSelect }: { onRadioSelect }) {
  return (
    <FieldSet required legend={<Legend>Have you already found your new tenants?</Legend>}>
      <LabeledControl
        label={<Label>Yes</Label>}
        control={
          <Radio
            name="have-you-already-found-your-new-tenants"
            onChange={onRadioSelect}
            value={WIZARD_SCREEN_TYPES.CONGRATULATIONS_IS_YOUR_NEW_LEASE_READY}
          />
        }
      />
      <LabeledControl
        label={<Label>No</Label>}
        control={
          <Radio
            name="have-you-already-found-your-new-tenants"
            onChange={onRadioSelect}
            value={WIZARD_SCREEN_TYPES.STEPS_TO_TAKE_TO_FIND_YOUR_NEXT_TENANTS}
          />
        }
      />
      <LabeledControl
        label={<Label>I don’t plan to rent anymore</Label>}
        control={
          <Radio
            name="have-you-already-found-your-new-tenants"
            onChange={onRadioSelect}
            value={WIZARD_SCREEN_TYPES.ARE_YOU_PLANNING_TO_SELL}
          />
        }
      />
    </FieldSet>
  );
}
